<template>
<div class="offices">
  Offices
</div>
</template>